import React from 'react';
import { ChevronDown } from 'lucide-react';
interface SelectOption {
  value: string;
  label: string;
}
interface SelectProps extends React.SelectHTMLAttributes<HTMLSelectElement> {
  label?: string;
  options: SelectOption[];
  fullWidth?: boolean;
  variant?: 'outlined' | 'filled' | 'sidebar';
}
export function Select({
  label,
  options,
  fullWidth = false,
  variant = 'outlined',
  className = '',
  ...props
}: SelectProps) {
  const baseStyles = 'appearance-none flex h-10 w-full rounded-full px-4 py-2 text-sm focus:outline-none focus:ring-2 focus:ring-navy-primary/20 disabled:cursor-not-allowed disabled:opacity-50 pr-8';
  const variants = {
    outlined: 'bg-white border border-gray-300 focus:border-navy-primary',
    filled: 'bg-navy-primary/10 border-transparent text-white placeholder-white/70',
    sidebar: 'bg-transparent border border-gray-600 text-white focus:border-white' // New variant for sidebar
  };
  return <div className={`${fullWidth ? 'w-full' : ''} flex flex-col gap-1.5`} data-id="element-296">
      {label && <label className="text-sm font-medium text-gray-700" data-id="element-297">{label}</label>}
      <div className="relative" data-id="element-298">
        <select className={`${baseStyles} ${variant === 'filled' ? 'bg-opacity-20 text-white border-none' : variants[variant]} ${className}`} {...props} data-id="element-299">
          {options.map(option => <option key={option.value} value={option.value} className="text-gray-900" data-id="element-300">
              {option.label}
            </option>)}
        </select>
        {variant === 'sidebar' /* Wide solid white downward triangle */ ? <svg className="absolute right-2.5 top-1/2 -translate-y-1/2 pointer-events-none" width="12" height="7" viewBox="0 0 12 7" fill="none" xmlns="http://www.w3.org/2000/svg" data-id="element-301">
            <polygon points="0,0 12,0 6,7" fill="white" data-id="element-302" />
          </svg> : <ChevronDown className={`absolute right-3 top-1/2 -translate-y-1/2 h-4 w-4 pointer-events-none ${variant === 'filled' ? 'text-white' : 'text-gray-500'}`} data-id="element-303" />}
      </div>
    </div>;
}